import React from 'react';

import { RouteManager } from '../../RouteManager';

import { AddDeviceDialog } from './add-device-dialog/AddDeviceDialog';
import { PairingDialog } from './PairingDialog';

export function PairingDelegator(props) {
  function handleClose() {
    RouteManager.pushState({});
  }

  switch (props.state.type) {
    case 'pair':
      return <AddDeviceDialog onClose={handleClose} zoneId={props.zoneId} />;
    case 'repair':
    case 'unpair':
      return (
        <PairingDialog
          type={props.state.type}
          driverId={props.state.driverId}
          deviceId={props.state.deviceId}
          onClose={handleClose}
        />
      );
    default:
      return null;
  }
}
